import { useQuery, keepPreviousData } from "@tanstack/react-query";
import type { SpyserpDateRangeParams } from "@/services/SpySerpService";
import { spySerpService } from "@/services/SpySerpService";
import { ensureSpyserpDateRange } from "@/hooks/spyserp/ensureSpyserpDateRange";

export const getSpyserpGlobalAlertsQueryKey = ({
  dateRange,
  customFrom,
  customTo,
}: SpyserpDateRangeParams) =>
  [
    "spyserp",
    "globalAlerts",
    dateRange,
    customFrom ?? null,
    customTo ?? null,
  ] as const;

export const useSpyserpGlobalAlerts = (params: SpyserpDateRangeParams) =>
  useQuery({
    queryKey: getSpyserpGlobalAlertsQueryKey(params),
    queryFn: async () => {
      const resolved = await ensureSpyserpDateRange(params);
      return spySerpService.getGlobalAlerts(resolved);
    },
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  });
